import { Directive, ElementRef, Renderer2, OnInit, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appScrollDirection]',
  standalone: true
})
export class ScrollDirectionDirective implements OnInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser: boolean = isPlatformBrowser(this.platformId);
  private lastScrollTop = 0;
  private scrollHandler?: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Initialize scroll listener only in browser and after a microtask delay
  // This prevents blocking Angular hydration stability
  ngOnInit(): void {
    if (!this.isBrowser) return;

    // Delay scroll listener attachment to allow app to stabilize after hydration
    setTimeout(() => {
      this.scrollHandler = this.onWindowScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }, 0);
  }

  // Clean up scroll listener to prevent memory leaks
  ngOnDestroy(): void {
    if (this.scrollHandler && this.isBrowser) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }

  private onWindowScroll(): void {
    if (!this.isBrowser) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.lastScrollTop) {
      // Scrolling down, hide header
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(-120%)');
    } else {
      // Scrolling up, show header
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(0)');
    }
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}
